import EventEmitter from 'eventemitter3';
import { FrameExtractor } from './FrameExtractor';
import { WebAudioEncoderImpl } from './WebAudioEncoderImpl';
export class AudioEncoderWrapper extends EventEmitter {
    audioEncoderWorker;
    audioEncoderImpl;
    audioFrameExtractor;
    constructor() {
        console.log('AudioEncoderWrapper constructor');
        super();
    }
    startAudioEncoderWorker(audioTrack) {
        console.log('startAudioEncoderWorker()');
        return new Promise((resolve, reject) => {
            if (this.audioEncoderWorker) {
                console.log('AudioEncoderWrapper exists, terminate it');
                this.audioEncoderWorker.terminate();
                this.audioEncoderWorker = undefined;
            }
            this.audioEncoderWorker = new Worker(new URL('./workers/audioencoder.worker.ts', import.meta.url));
            this.audioEncoderWorker.onmessage = (e) => {
                const { type, data } = e.data;
                switch (type) {
                    case 'audioData':
                        this.emit('audioData', data);
                        break;
                    case 'audioVolume':
                        this.emit('audioVolume', data);
                        break;
                    case 'audioEncoderSupportResult':
                        if (!data.isAudioEncoderSupported) {
                            this.audioEncoderWorker?.terminate();
                            this.audioEncoderWorker = undefined;
                            console.log('AudioEncoder not supported in worker');
                            reject();
                        }
                        else {
                            this.audioEncoderWorker?.postMessage({
                                type: 'start',
                                audioTrack: audioTrack,
                            });
                            console.log('AudioEncoder supported in worker');
                            resolve();
                        }
                        break;
                    case 'stopCompleted':
                        this.emit('workerStopped');
                        break;
                }
            };
            this.audioEncoderWorker.postMessage({
                type: 'checkAudioEncoderSupport',
            });
        });
    }
    async startAudioEncoderImpl(audioTrack) {
        this.audioEncoderImpl?.emitter.on('audioData', (audioData) => this.emit('audioData', audioData));
        this.audioEncoderImpl?.emitter.on('audioVolume', (volume) => this.emit('audioVolume', volume));
        await this.audioEncoderImpl?.start(audioTrack);
    }
    async start(audioTrack) {
        // Create FrameExtractor in worker on Safari
        // in main thread on Chrome
        const createFrameExtractorInWorker = typeof MediaStreamTrackProcessor === 'undefined';
        console.log('AudioEncoderWrapper::start() createFrameExtractorInWorker', createFrameExtractorInWorker);
        if (this.audioFrameExtractor) {
            await this.audioFrameExtractor.stop();
        }
        try {
            // On Safari, AudioEncoder is behind a flag
            console.log('trying to startAudioEncoderWorker()');
            await this.startAudioEncoderWorker(createFrameExtractorInWorker ? audioTrack : undefined);
            if (!createFrameExtractorInWorker) {
                this.audioFrameExtractor = new FrameExtractor(audioTrack);
                this.audioFrameExtractor.emitter.on('frame', (frame) => {
                    this.audioEncoderWorker?.postMessage({
                        type: 'feedAudioFrame',
                        audioFrame: frame,
                    }, [frame]);
                });
                this.audioFrameExtractor.start();
            }
        }
        catch (_e) {
            // Fallback to WebAudioEncoderImpl, used in Safari
            console.log('Fallback to WebAudioEncoderImpl');
            this.audioEncoderImpl = new WebAudioEncoderImpl();
            await this.startAudioEncoderImpl(audioTrack);
        }
    }
    async stop() {
        await this.audioFrameExtractor?.stop();
        await this.audioEncoderImpl?.stop();
        if (this.audioEncoderWorker) {
            return new Promise((resolve, _reject) => {
                this.once('workerStopped', () => {
                    this.audioEncoderWorker?.terminate();
                    resolve();
                });
                this.audioEncoderWorker?.postMessage({
                    type: 'stop',
                });
            });
        }
    }
}
